export default __webpack_public_path__ + "static/media/member-3.6e0ce9bb.png";